// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__2ZcgV","content":"content__1_E1o"};